// extracted by mini-css-extract-plugin
export default {"scrollArrow":"scroll-arrow_scrollArrow__pFcpp","visible":"scroll-arrow_visible__KBVDz","hidden":"scroll-arrow_hidden__meiug"};